// extracted by mini-css-extract-plugin
export default {"root":"public_pages__root--GVv0v"};